const handleCellPointerDown = (params) => {
  const cellWrapperDiv = params.event.target.closest(`.ag-row[row-index = "${params.rowIndex}"]>.ag-cell[col-id = "${params.column.colId}"]`);
  if (cellWrapperDiv) {
    cellWrapperDiv.classList.add('ag-click-focus-animatable');
    const timeout = setTimeout(() => {
      cellWrapperDiv.classList.remove('ag-click-focus-animatable');
      clearTimeout(timeout);
    }, 600);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { handleCellPointerDown };
